import {ComponentConfiguration} from '@twpub/core/utils';
import {ComponentFieldModel, ConfigurableComponent} from '@twpub/core/models';

export class DropdownComponent {
  static readonly MULTIPLE_SELECT = 'multipleSelect';
  static readonly INCLUDE_ALL_OPTION = 'selectAll';
  static readonly DEFAULT_VALUE = 'defaultValue';

  /**
   * Shared getFields implementation for dropdown components.
   * Handles conversion between single-select and multi-select modes,
   * preserving the first value when switching from multi to single.
   */
  static getFields(
    compConfig: ComponentConfiguration<ConfigurableComponent>,
    baseFields: ComponentFieldModel<any>[]
  ): ComponentFieldModel<any>[] {
    // Make DEFAULT_VALUE dropdown support multiple selections if MULTIPLE_SELECT is true
    const multipleSelect = compConfig.getBoolean(DropdownComponent.MULTIPLE_SELECT);
    const defaultValueField = baseFields.find(f => f.key === DropdownComponent.DEFAULT_VALUE);

    if (defaultValueField) {
      defaultValueField.multiple = multipleSelect;
      defaultValueField.description = multipleSelect
        ? 'Select one or more default values'
        : 'Select a default value';

      // Convert stored value format based on multipleSelect setting
      const currentValue = compConfig.getConfigValue(DropdownComponent.DEFAULT_VALUE);

      if (multipleSelect) {
        // For multi-select: convert string to array for display
        if (typeof currentValue === 'string' && currentValue) {
          defaultValueField.value = currentValue.split(';').filter(v => v);
        } else if (Array.isArray(currentValue)) {
          defaultValueField.value = currentValue;
        } else {
          defaultValueField.value = [];
        }
      } else {
        // For single-select: take first value from string or array
        if (typeof currentValue === 'string' && currentValue) {
          // Extract first value from semicolon-separated string
          const firstValue = currentValue.split(';').filter(v => v)[0];
          defaultValueField.value = firstValue || '';
        } else if (Array.isArray(currentValue) && currentValue.length > 0) {
          defaultValueField.value = currentValue[0];
        } else {
          defaultValueField.value = '';
        }
      }
    }

    return baseFields;
  }
}
